const LOCAL_API = 'http://localhost:4000/api';
const PROD_API = 'https://crm.bufsa.com/api';
const LOCAL_ORIGIN = 'http://localhost:4000';
const PROD_ORIGIN = 'https://crm.bufsa.com';

function stripTrailingSlash(value: string): string {
  return value.replace(/\/+$/, '');
}

function isLocalHostname(hostname: string): boolean {
  return hostname === 'localhost' || hostname === '127.0.0.1' || hostname === '[::1]';
}

function hostnameOfUrl(value: string): string | null {
  try {
    return new URL(value).hostname;
  } catch {
    return null;
  }
}

export function isLocalhostUrl(value: string): boolean {
  const hostname = hostnameOfUrl(value);
  if (hostname) {
    return isLocalHostname(hostname);
  }

  return /localhost|127\.0\.0\.1|\[::1\]/i.test(value);
}

function configuredApiBase(): string | undefined {
  const gateway = process.env.REACT_APP_API_GATEWAY_URL?.trim();
  const base = process.env.REACT_APP_BASE_URL?.trim();
  const value = gateway || base;
  return value ? stripTrailingSlash(value) : undefined;
}

function configuredAuthOrigin(): string | undefined {
  const auth = process.env.REACT_APP_AUTH_HOST?.trim();
  if (auth) {
    return stripTrailingSlash(auth);
  }

  const api = configuredApiBase();
  if (!api) {
    return undefined;
  }

  try {
    return new URL(api).origin;
  } catch {
    return undefined;
  }
}

function currentHostname(): string | undefined {
  if (typeof window === 'undefined') {
    return undefined;
  }

  return window.location.hostname;
}

export function isLocalBrowserStand(): boolean {
  const hostname = currentHostname();
  return Boolean(hostname && isLocalHostname(hostname));
}

function resolvePublicHost(options: {
  configured: string | undefined;
  localValue: string;
  prodValue: string;
}): string {
  const { configured, localValue, prodValue } = options;
  const hostname = currentHostname();

  if (hostname && isLocalHostname(hostname)) {
    if (configured && isLocalhostUrl(configured)) {
      return configured;
    }
    return localValue;
  }

  if (hostname) {
    if (configured && !isLocalhostUrl(configured)) {
      return configured;
    }
    return prodValue;
  }

  if (process.env.NODE_ENV === 'production') {
    if (configured && !isLocalhostUrl(configured)) {
      return configured;
    }
    return prodValue;
  }

  return configured || localValue;
}

export function getGatewayBaseUrl(): string {
  return resolvePublicHost({
    configured: configuredApiBase(),
    localValue: LOCAL_API,
    prodValue: PROD_API,
  });
}

export function getAuthHost(): string {
  return resolvePublicHost({
    configured: configuredAuthOrigin(),
    localValue: LOCAL_ORIGIN,
    prodValue: PROD_ORIGIN,
  });
}
